import React from "react";
import firebase from "firebase";

const firebaseConfig = {
	apiKey: "AIzaSyAGYIr41mmYovrjmzgxGwi9dieXN_ZPIwM",
	authDomain: "web-app-72aea.firebaseapp.com",
	projectId: "web-app-72aea",
	storageBucket: "web-app-72aea.appspot.com",
	messagingSenderId: "484943538126",
	appId: "1:484943538126:web:a3fd022d245d1ff917ed9f",
	measurementId: "G-4FFGCH9ZLE",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();

const auth = firebase.auth();

export { db, auth };
